<main class="container mt-4">
  <div class="back-link mb-4">
    <a class="click" (click)="goHome()">&larr; Back to Dashboard</a>
  </div>

  <div class="form-card">
    <h1 class="form-title">Post a new job advertisement</h1>
    <p class="form-subtitle">Fill out the details below so our AI can match you with the perfect candidates.</p>

    <form class="job-form" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <label for="job-title">Job Title</label>
        <input type="text" id="job-title" name="title" placeholder="e.g. Product designer" [(ngModel)]="title" required>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="location">Location</label>
          <input type="text" id="location" name="location" placeholder="e.g. Budapest XI. or Remote"
            [(ngModel)]="location" required>
        </div>

        <div class="form-group">
          <label for="employment-type">Employment Type</label>
          <select id="employment-type" name="employmentType" [(ngModel)]="employmentType">
            <option value="0">Full-time</option>
            <option value="1">Part-time</option>
            <option value="2">Internship</option>
            <option value="3">Temporary</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label for="salary">Salary / Payment (Optional)</label>
        <input type="text" id="salary" name="salary" placeholder="e.g. 600 000 Ft / month" [(ngModel)]="salary">
      </div>

      <div class="form-group">
        <label for="tags">Tags (comma separated)</label>
        <input type="text" id="tags" name="tags" placeholder="e.g. Angular, C#, Frontend" [(ngModel)]="tags">
      </div>

      <div class="form-group">
        <label for="shorDescription">Job Short Description</label>
        <textarea class="preview-textarea" id="description" name="shortDescription" rows="3"
          placeholder="Describe the role in short...." [(ngModel)]="shortDescription" required></textarea>
      </div>

      @if(isPreView$ | async){
      <div class="form-group">
        <label>Job Description Preview</label>

        <div class="preview-content" [innerHTML]="preViewmd | async"></div>

        <div class="prev-container">
          <button type="button" class="btn btn-primary button-design" (click)="preView()">
            Back
          </button>
        </div>
      </div>
      }@else{
      <div class="form-group">
        <label for="description">Job Description</label>
        <textarea class="preview-textarea" id="description" name="description" rows="6"
          placeholder="Describe the role, responsibilities, and requirements..." [(ngModel)]="description"
          required></textarea>
        <div class="prev-container">
          <button type="button" class="btn btn-primary button-design" (click)="preView()">
            PreView
          </button>
        </div>
      </div>
      }

      @if (error) {
      <div class="mb-3 text-center">
        <p class="text-danger fw-bold">{{ error }}</p>
      </div>
      }

      <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? 'Posting...' : 'Post Advertisement'}}
      </button>
    </form>
  </div>
</main>